<div>
  <app-logo path="assets/samplelist-logo.svg"></app-logo>
  <h1>Sampleliste.de</h1>
  <ng-container *ngIf="!loginWithEmail">
    <button mat-raised-button color="primary" (click)="login('facebook')">
      Login mit Facebook
    </button>
    <button mat-raised-button color="primary" (click)="loginWithEmail = !loginWithEmail">
      Login mit Email
    </button>
  </ng-container>
  <app-login-email *ngIf="loginWithEmail" [(loginWithEmail)]="loginWithEmail"></app-login-email>
</div>
